import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const COAST_IMG =
  "https://images.unsplash.com/photo-1755467020939-4c3e196545bd?fm=jpg&q=80&w=2400&auto=format&fit=crop";

export default function Story() {
  return (
    <section id="story" data-testid="story-section" className="border-t border-zinc-200 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.1fr]"
        >
          <div>
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">The name</p>
            <h2 className="font-display text-3xl font-extrabold tracking-tighter sm:text-4xl lg:text-5xl">
              Poitín means <span className="font-serif italic font-medium">defiance.</span>
            </h2>
            <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400">
              Urris &middot; Inishowen &middot; Co. Donegal &middot; 55.28&deg;N 7.48&deg;W
            </p>
          </div>

          <div className="space-y-6 text-sm leading-relaxed text-zinc-600 sm:text-base">
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.1, ease: EASE }}
            >
              In Urris, on the Inishowen peninsula of Co. Donegal, the locals once declared their
              own Poitín Republic — a small, self-governed stand of neighbours holding together
              against outside rule. It was never really about the drink. It was about independence,
              unity, and refusing to hand your livelihood to someone else's rules.
            </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.2, ease: EASE }}
            >
              This company runs on the same idea. Independent, self-reliant, and built around the
              people it serves — the bands. When you work with Poitín Republic, you're not routed
              through a faceless merch corporation. You deal with one hub that designs, prints where
              you play, and answers when you call.
            </motion.p>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.35 }}
              className="flex items-center gap-4 border-t border-zinc-200 pt-6"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-tour-red" />
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
                Independent by name. Independent by nature.
              </p>
            </motion.div>
          </div>
        </motion.div>

        <motion.figure
          data-testid="story-coast-image"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
          className="mt-16 sm:mt-20"
        >
          <div className="relative overflow-hidden border border-zinc-200">
            <img
              src={COAST_IMG}
              alt="Malin Head coastline, Inishowen, Co. Donegal"
              loading="lazy"
              className="aspect-[16/9] w-full object-cover sm:aspect-[21/9]"
              style={{ filter: "grayscale(1) contrast(1.15) brightness(0.95)" }}
            />
            <div
              className="pointer-events-none absolute inset-0"
              style={{ background: "linear-gradient(to top, rgba(9,9,11,0.35), transparent 40%)" }}
            />
          </div>
          <figcaption className="mt-3 flex flex-col justify-between gap-1 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400 sm:flex-row">
            <span>Malin Head &middot; Inishowen &middot; Co. Donegal</span>
            <span>The edge of the republic</span>
          </figcaption>
        </motion.figure>
      </div>
    </section>
  );
}
